const styles = {
  container: {
    padding: '30px',
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    fontFamily: 'Segoe UI, sans-serif',
    transition: 'margin-left 0.3s ease',
  },
  header: {
    color: '#1B019B',
    fontWeight: '600',
    fontSize: '1.5rem',
    textAlign: 'center'
  },
  hr: {
    width: '80px',
    border: '2px solid #1B019B',
    opacity: '1',
    margin: '10px auto 20px',
  },
  organisationHeader: {
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px',
    gap: '15px'
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  filterLabel: {
    fontWeight: '600', 
    color: '#1B019B'
  },
  filterIcon: {
    color: '#1B019B'
  },
  searchBar: {
    borderRadius: '20px',
    paddingLeft: '15px',
    height: '38px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    minWidth: '250px'
  },
  select: {
    borderRadius: '20px',
    height: '38px',
    padding: '0 15px',
    fontSize: '1rem',
    minWidth: '180px'
  },
  exportButton: {
    backgroundColor: '#1B019B',
    color: 'white',
    border: 'none',
    borderRadius: '30px',
    padding: '8px 20px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer'
  },
  card: {
    borderRadius: '15px',
    border: 'none',
    boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
    padding: '20px',
    textAlign: 'center'
  },
  positiveCard: {
    backgroundColor: '#d4edda',
    color: '#155724'
  },
  negativeCard: {
    backgroundColor: '#f8d7da',
    color: '#721c24'
  },
  neutralCard: {
    backgroundColor: '#e2e3e5',
    color: '#383d41'
  },
  tableHeader: {
    backgroundColor: '#1B019B',
    color: '#fff',
  }
};

export default styles;